import { Box, Flex, Text, Button, VStack, } from "@chakra-ui/react";

import { INVOICES, STATUS_STYLES } from "./constants";
import { formatAmount, formatDate } from "./helpers";
import { Invoice, InvoiceStatus } from "./types";
import { Card, DownloadIcon } from "./UI";

interface InvoicesCardProps {
  invoices?: Invoice[];
  onDownload?: (invoice: Invoice) => void;
}

export function InvoicesCard({
  invoices = INVOICES,
  onDownload = (inv) => alert(`Téléchargement : ${inv.number}`),
}: InvoicesCardProps) {
    return (
        <Card gridColumn={{ lg: "span 2" }} overflow="hidden">
            <Flex justify="space-between" align="center" mb={5}>
                <Text fontFamily="heading" fontSize="lg" color="gray.900">Factures</Text>
                <Text fontSize="xs" color="gray.400">
                    {invoices.length} document{invoices.length > 1 ? "s" : ""}
                </Text>
            </Flex>

            <Box overflowX="auto" mx={-6} px={6}>
                <Box minW="500px">
                    <Flex px={3} pb={2}>
                        <Box flex="2" minW="110px">
                            <Text fontSize="xs" color="gray.400" textTransform="uppercase" letterSpacing="wider">N° facture</Text>
                        </Box>
                        <Box flex="3" minW="130px">
                            <Text fontSize="xs" color="gray.400" textTransform="uppercase" letterSpacing="wider">Description</Text>
                        </Box>
                        <Box w="76px" textAlign="right">
                            <Text fontSize="xs" color="gray.400" textTransform="uppercase" letterSpacing="wider">Montant</Text>
                        </Box>
                        <Box w="86px" textAlign="center">
                            <Text fontSize="xs" color="gray.400" textTransform="uppercase" letterSpacing="wider">Statut</Text>
                        </Box>
                        <Box w="60px" />
                    </Flex>

                    <VStack spacing={1} align="stretch">
                        {invoices.map((inv, i) => {
                            const s = STATUS_STYLES[inv.status as InvoiceStatus];
                                return (
                                    <Flex key={inv.id} align="center" px={3} py={3} borderRadius="12px"
                                          bg={i % 2 === 0 ? "surface.subtle" : "white"}
                                          _hover={{ bg: "brand.50" }} transition="background 0.15s">
                                        <Box flex="2" minW="110px">
                                            <Text fontSize="sm" fontWeight="600" color="gray.800" noOfLines={1}>{inv.number}</Text>
                                            <Text fontSize="xs" color="gray.400">{formatDate(inv.date)}</Text>
                                        </Box>
                                        <Box flex="3" minW="130px">
                                            <Text fontSize="sm" color="gray.500" noOfLines={1}>{inv.description}</Text>
                                        </Box>
                                        <Box w="76px" textAlign="right">
                                            <Text fontSize="sm" fontWeight="700" color="gray.900">{formatAmount(inv.amount)}</Text>
                                        </Box>
                                        <Flex w="86px" justify="center">
                                            <Box px={2} py="2px" borderRadius="full" bg={s.bg}>
                                                <Text fontSize="xs" fontWeight="600" color={s.color} whiteSpace="nowrap">{s.label}</Text>
                                            </Box>
                                        </Flex>
                                        <Flex w="60px" justify="flex-end">
                                            <Button size="xs" variant="ghost" color="brand.500" _hover={{ bg: "brand.50" }}
                                                    leftIcon={<DownloadIcon />} onClick={() => onDownload(inv)}>
                                                PDF
                                            </Button>
                                        </Flex>
                                    </Flex>
                                );
                        })}
                    </VStack>
                </Box>
            </Box>
        </Card>
    );
}